export default __webpack_public_path__ + "pages/slides-8df71c753bdd0dacc3c6da582688a918.html";